import React, { useEffect, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import WeekdayTableView from "./WeekdayTableView";
import { useSelector } from "react-redux";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
};
export default function ViewSalesOrder() {
  const { adminDetails } = useSelector((state) => state.AdminReducer);
  const navigate = PagesIndex.useNavigate();
  const params = PagesIndex.useParams();
  const { id } = params;
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [modalDataOrder, setModalDataOrder] = useState({});
  const [creativeData, setCreativeData] = useState([]);
  const [programData, setProgramData] = useState([]);
  const handleGetBookingDetails = () => {
    PagesIndex.apiGetHandler(
      PagesIndex.Api.GET_SALES_ORDER_DETAILS + "/" + id
    ).then((res) => {
      if (res.status === 200) {
        setData(res.data);
      }
      setLoading(false);
    });
  };
  const handleGetCreatives = () => {
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_CREATIVES).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setCreativeData(res.data);
      }
    });
  };
  const handleGetProgram = () => {
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_PROGRAM).then((res) => {
      if (res.status === 200) {
        setProgramData(res?.data);
      }
    });
  };
  const handleDownloadVideo = async (data) => {
    const a = document.createElement("a");

    a.setAttribute("download", data?.documentsName); // Replace with the desired filename for the downloaded file
    a.href = process.env.REACT_APP_IMAGE_ENDPOINT + data?.file;
    a.click();
    window.URL.revokeObjectURL(
      process.env.REACT_APP_IMAGE_ENDPOINT + data?.file
    );
  };
  useEffect(() => {
    handleGetCreatives();
    handleGetProgram();
    handleGetBookingDetails();
  }, []);
  const [openViewBookingDetails, setOpenViewBookingDetails] =
    React.useState(false);
  const handleOpenViewBookingDetails = (data) => {
    setOpenViewBookingDetails(true);
    setModalDataOrder(data);
  };
  const handleCloseViewBookingDetails = () => {
    setOpenViewBookingDetails(false);
    setModalDataOrder({});
  };
  return (
    <>
      {loading ? (
        <PagesIndex.Loader />
      ) : (
        <Index.Box className="admin-dashboard-content admin-view-sales-content">
          <Index.Box className="admin-user-list-flex admin-page-title-main view-page-title-main">
            <Index.Box className="admin-title-left">
              <Index.Button
                className="admin-adduser-btn btn-primary back-btn"
                onClick={() => {
                  navigate(`/admin/sales-order-list`);
                }}
              >
                <img
                  src={PagesIndex.Svg.backarrow}
                  className="admin-icon edit-icons"
                  alt="plus"
                />
              </Index.Button>
              <Index.Typography
                className="admin-view-page-title"
                component="h2"
                variant="h2"
              >
                <span className="title-text">
                  Order Details{" "}
                  <span className="sales-order-id-text">
                    {" "}
                    ({data?.salesOrder?.orderNo})
                  </span>
                </span>
              </Index.Typography>
            </Index.Box>
          </Index.Box>

          <Index.Box className="view-details-card">
            <Index.Box className="admin-file-view-card common-card">
              <Index.Box className="admin-file-view-main">
                <Index.Box className="highlight-box">
                  <Index.Box className="highlight-flex">
                    <Index.Typography className="highlight-content-lable">
                      Clinet Name
                    </Index.Typography>
                    <Index.Typography className="highlight-content-data">
                      {data?.salesOrder?.client?.firstName}
                    </Index.Typography>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <Index.Box className="reaction-icon-flex sales-order-review-flex">
                <Index.Box className="review-box">
                  <Index.Typography className="review-title">
                    Start Date
                  </Index.Typography>
                  <Index.Typography className="review-data">
                    {PagesIndex.moment(data?.salesOrder?.startDate).format(
                      "DD/MM/YYYY"
                    )}
                  </Index.Typography>
                </Index.Box>
                <Index.Box className="review-box">
                  <Index.Typography className="review-title">
                    End Date
                  </Index.Typography>
                  <Index.Typography className="review-data">
                    {PagesIndex.moment(data?.salesOrder?.endDate).format(
                      "DD/MM/YYYY"
                    )}
                  </Index.Typography>
                </Index.Box>
              </Index.Box>
              <Index.Box className="status-highlight-box-flex">
                <Index.Typography className="status-text">
                  Status
                  <span className="status-text-span">
                    {data?.salesOrder?.status}
                  </span>
                </Index.Typography>
              </Index.Box>
            </Index.Box>
            <Index.Box className="news-view-content-main common-card">
              <Index.Box className="other-flex">
                <Index.Box className="admin-sub-title-main">
                  <Index.Typography
                    className="admin-sub-title"
                    component="h2"
                    variant="h2"
                  >
                    Creative Summary
                  </Index.Typography>
                </Index.Box>
              </Index.Box>
              <Index.Box className="page-table-main">
                <Index.TableContainer
                  component={Index.Paper}
                  className="table-container"
                >
                  <Index.Table aria-label="simple table" className="table">
                    <Index.TableHead className="table-head">
                      <Index.TableRow className="table-row">
                        <Index.TableCell
                          component="th"
                          variant="th"
                          className="table-th"
                          width="20%"
                        >
                          Element
                        </Index.TableCell>
                        <Index.TableCell
                          component="th"
                          variant="th"
                          className="table-th"
                          width="40%"
                        >
                          Advertisement
                        </Index.TableCell>
                        <Index.TableCell
                          component="th"
                          variant="th"
                          className="table-th"
                          width="20%"
                        >
                          Used Units
                        </Index.TableCell>
                      </Index.TableRow>
                    </Index.TableHead>
                    <Index.TableBody className="table-body">
                      {data?.creativeData?.length ? (
                        data?.creativeData?.map((data) => {
                          return (
                            <Index.TableRow
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <Index.TableCell
                                component="td"
                                variant="td"
                                scope="row"
                                className="table-td"
                              >
                                <Index.Typography className="admin-table-data-text">
                                  {data?.element}
                                </Index.Typography>
                              </Index.TableCell>
                              <Index.TableCell
                                component="td"
                                variant="td"
                                className="table-td"
                              >
                                <Index.Typography className="admin-table-data-text">
                                  {data?.creative}
                                </Index.Typography>
                              </Index.TableCell>
                              <Index.TableCell
                                component="td"
                                variant="td"
                                className="table-td"
                              >
                                {data?.duration}
                              </Index.TableCell>
                            </Index.TableRow>
                          );
                        })
                      ) : (
                        <PagesIndex.DataNotFound />
                      )}
                      <Index.TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <Index.TableCell
                          component="td"
                          variant="td"
                          scope="row"
                          className="table-td"
                        ></Index.TableCell>
                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                          align="right"
                        >
                          <Index.Box className="total-text">
                            Total Used Units :
                          </Index.Box>
                        </Index.TableCell>
                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          <Index.Box className="total-text">
                            {parseFloat(
                              data?.creativeData?.reduce((total, item) => {
                                return (
                                  total + parseFloat(item?.duration || 0, 0)
                                );
                              }, 0) || 0
                            )?.toLocaleString("en-US")}
                          </Index.Box>
                        </Index.TableCell>
                      </Index.TableRow>
                    </Index.TableBody>
                  </Index.Table>
                </Index.TableContainer>
              </Index.Box>
            </Index.Box>
          </Index.Box>
          {data?.salesOrder?.document?.length !== 0 && (
            <>
              <Index.Box className="view-sales-approve-box">
                <Index.Box className="view-sales-approve-flex">
                  <Index.Box className="admin-sub-title-main">
                    <Index.Typography
                      className="admin-sub-title"
                      component="h2"
                      variant="h2"
                    >
                      List of Attachment
                    </Index.Typography>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <Index.Box className="common-card attechment-card">
                {data?.salesOrder?.document?.map((url) => {
                  return (
                    // <Index.Box
                    //   className="sales-attechment-flex-box"
                    //   key={ele?._id}
                    // >
                    //   <Index.Box className="sales-attechment-box">
                    //     <Index.Typography className="sales-approve-attechment-name">
                    //       {ele?.file}
                    //     </Index.Typography>
                    //   </Index.Box>
                    // </Index.Box>

                    <Index.Box className="document-data-flex" key={url?.file}>
                      <Index.Box className="document-lable-flex">
                        <Index.Typography className="document-id-text">
                          {url?.name?.toUpperCase()}
                        </Index.Typography>
                        <Index.Typography className="document-lable-text">
                          {url?.file}
                        </Index.Typography>
                      </Index.Box>
                      <Index.Box className="document-content-main">
                        <Index.Box className="document-delete-main">
                          <Index.Button
                            className="admin-table-data-btn"
                            onClick={() => handleDownloadVideo(url)}
                          >
                            <img
                              src={PagesIndex.Svg.download}
                              className="admin-icon"
                              alt="Download"
                            ></img>
                          </Index.Button>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  );
                })}
              </Index.Box>
            </>
          )}
          <Index.Box className="other-flex">
            <Index.Box className="admin-sub-title-main">
              <Index.Typography
                className="admin-sub-title"
                component="h2"
                variant="h2"
              >
                Deal Details
              </Index.Typography>
            </Index.Box>
          </Index.Box>
          <Index.Box className="common-card">
            <Index.Box
              className={`admin-order-details-table-main page-table-main`}
            >
              <Index.TableContainer
                component={Index.Paper}
                className="table-container"
              >
                <Index.Table aria-label="simple table" className="table">
                  <Index.TableHead className="table-head">
                    <Index.TableRow className="table-row">
                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="2%"
                      >
                        Sr. No.
                      </Index.TableCell>

                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="5%"
                      >
                        Platform
                      </Index.TableCell>

                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="5%"
                      >
                        Element
                      </Index.TableCell>

                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="5%"
                      >
                        Total Units
                      </Index.TableCell>
                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="5%"
                      >
                        Remaining Units
                      </Index.TableCell>
                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="5%"
                      >
                        Rate
                      </Index.TableCell>
                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="5%"
                      >
                        Selling Rate
                      </Index.TableCell>

                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        width="5%"
                      >
                        Amount
                      </Index.TableCell>
                      {adminDetails?.roleId?.permissions?.includes(
                        "slot_schedule_view"
                      ) && (
                        <Index.TableCell
                          component="th"
                          variant="th"
                          className="table-th"
                          width="5%"
                          align="right"
                        >
                          Action
                        </Index.TableCell>
                      )}
                    </Index.TableRow>
                  </Index.TableHead>
                  <Index.TableBody className="table-body">
                    {data?.salesOrder?.orderDetails?.map((ele, index) => {
                      return (
                        <Index.TableRow className="table-row" key={ele?._id}>
                          <Index.TableCell
                            component="td"
                            variant="td"
                            className="table-td"
                          >
                            {index + 1}
                          </Index.TableCell>

                          <Index.TableCell
                            component="td"
                            variant="td"
                            className="table-td"
                          >
                            {ele?.platform}
                          </Index.TableCell>

                          <Index.TableCell
                            component="td"
                            variant="td"
                            className="table-td"
                          >
                            {ele?.elements}
                          </Index.TableCell>

                          <Index.TableCell
                            component="td"
                            variant="td"
                            className="table-td"
                          >
                            {ele?.totalSeconds}
                          </Index.TableCell>
                          <Index.TableCell
                            component="td"
                            variant="td"
                            className="table-td"
                          >
                            <Index.Typography className="admin-table-data-text">
                              {ele?.remainingUnits}
                            </Index.Typography>
                          </Index.TableCell>
                          <Index.TableCell
                            component="td"
                            variant="td"
                            className="table-td"
                          >
                            {parseFloat(ele?.rate)?.toLocaleString("en-Us")}
                          </Index.TableCell>
                          <Index.TableCell
                            component="td"
                            variant="td"
                            className="table-td"
                          >
                            {ele?.discountrate}
                          </Index.TableCell>

                          <Index.TableCell
                            component="td"
                            variant="td"
                            className="table-td"
                          >
                            {parseFloat(ele?.amount)?.toLocaleString("en-Us")}
                          </Index.TableCell>
                          {adminDetails?.roleId?.permissions?.includes(
                            "slot_schedule_view"
                          ) && (
                            <Index.TableCell
                              component="td"
                              variant="td"
                              align="right"
                              className="table-td"
                            >
                              <Index.Box className="admin-table-data-btn-flex ">
                                <Index.Tooltip
                                  title="View Schedule"
                                  arrow
                                  placement="bottom"
                                  className="admin-tooltip"
                                >
                                  {ele?.platform === "TV FCT" ||
                                  ele?.platform === "TV Non FCT" ? (
                                    <Index.Button
                                      className="admin-table-data-btn abc"
                                      onClick={() => {
                                        if (ele?.platform === "TV FCT") {
                                          navigate(
                                            `/admin/add-slot-schedule-sales/FCT/${ele?.schedule?._id}/${ele?._id}`,
                                            {
                                              state: data?.salesOrder,
                                            }
                                          );
                                        }
                                        if (ele?.platform === "TV Non FCT") {
                                          navigate(
                                            `/admin/view-slot-schedule-sales/NonFCT/${ele?.schedule?._id}/${ele?._id}`,
                                            {
                                              state: data?.salesOrder,
                                            }
                                          );
                                        }
                                      }}
                                    >
                                      <img
                                        src={PagesIndex.Svg.CalenderColorIcon}
                                        className="admin-icon"
                                        alt="View"
                                      />
                                    </Index.Button>
                                  ) : (
                                    "-"
                                  )}
                                </Index.Tooltip>
                              </Index.Box>
                            </Index.TableCell>
                          )}
                        </Index.TableRow>
                      );
                    })}

                    <Index.TableRow>
                      <Index.TableCell
                        component="td"
                        variant="td"
                        className="table-td"
                      ></Index.TableCell>
                      <Index.TableCell
                        component="td"
                        variant="td"
                        className="table-td"
                      ></Index.TableCell>
                      <Index.TableCell
                        component="td"
                        variant="td"
                        className="table-td"
                      ></Index.TableCell>
                      <Index.TableCell
                        component="td"
                        variant="td"
                        className="table-td"
                      ></Index.TableCell>
                      <Index.TableCell
                        component="td"
                        variant="td"
                        className="table-td"
                      ></Index.TableCell>
                      <Index.TableCell
                        component="td"
                        variant="td"
                        className="table-td"
                      ></Index.TableCell>
                      <Index.TableCell
                        component="td"
                        variant="td"
                        className="table-td"
                        align="right"
                      >
                        <Index.Box className="total-text">
                          Total Amount:
                        </Index.Box>
                      </Index.TableCell>
                      <Index.TableCell
                        component="td"
                        variant="td"
                        className="table-td"
                      >
                        {parseFloat(
                          data?.salesOrder?.totalAmount || 0
                        )?.toLocaleString("en-Us")}
                      </Index.TableCell>
                      <Index.TableCell
                        component="td"
                        variant="td"
                        className="table-td"
                      ></Index.TableCell>
                    </Index.TableRow>
                  </Index.TableBody>
                </Index.Table>
              </Index.TableContainer>
            </Index.Box>
          </Index.Box>
          {data?.SubSalesOrder?.length ? (
            <>
              <Index.Box className="other-flex">
                <Index.Box className="admin-sub-title-main">
                  <Index.Typography
                    className="admin-sub-title"
                    component="h2"
                    variant="h2"
                  >
                    Booking Details
                  </Index.Typography>
                </Index.Box>
              </Index.Box>
              <Index.Box className="common-card">
                <Index.Box
                  className={`admin-previous-order-details-table-main page-table-main`}
                >
                  <Index.TableContainer
                    component={Index.Paper}
                    className="table-container"
                  >
                    {data?.SubSalesOrder?.map((dataOuter, index) => {
                      return (
                        <>
                          <Index.Box className="name-highlight-box-flex">
                            <Index.Box className="name-highlight-box">
                              <Index.Typography className="name-highlight-text">
                                {dataOuter?.name} -{" "}
                                <span className="name-highlight-id-text">
                                  {dataOuter?.subOrderNo}
                                </span>
                              </Index.Typography>
                            </Index.Box>
                            <Index.Box className="date-box-flex">
                              <Index.Typography className="date-text">
                                Start Date:
                                <span className="date-text-span">
                                  {PagesIndex.moment(
                                    dataOuter?.startDate
                                  ).format("DD/MM/YYYY")}
                                </span>
                              </Index.Typography>
                              <Index.Typography className="date-text">
                                End Date:
                                <span className="date-text-span">
                                  {PagesIndex.moment(dataOuter?.endDate).format(
                                    "DD/MM/YYYY"
                                  )}
                                </span>
                              </Index.Typography>
                              <Index.Typography className="date-text">
                                Created Date & Time:
                                <span className="date-text-span">
                                  {PagesIndex.moment(
                                    dataOuter?.createdAt
                                  ).format("DD/MM/YYYY hh:mm:ss A")}
                                </span>
                              </Index.Typography>
                            </Index.Box>
                          </Index.Box>
                          <Index.Table
                            aria-label="simple table"
                            className="table"
                            key={data?._id}
                          >
                            <Index.TableHead className="table-head">
                              <Index.TableRow className="table-row">
                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="2%"
                                >
                                  Sr. No.
                                </Index.TableCell>

                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="5%"
                                >
                                  Platform
                                </Index.TableCell>

                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="5%"
                                >
                                  Element
                                </Index.TableCell>

                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="5%"
                                >
                                  Total
                                </Index.TableCell>

                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="5%"
                                >
                                  Selling Rate
                                </Index.TableCell>

                                {/* <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="5%"
                                >
                                  Remaining Units
                                </Index.TableCell> */}

                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="5%"
                                >
                                  Used Units
                                </Index.TableCell>

                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="5%"
                                >
                                  Amount
                                </Index.TableCell>
                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="5%"
                                  align="right"
                                >
                                  Action
                                </Index.TableCell>
                              </Index.TableRow>
                            </Index.TableHead>
                            <Index.TableBody className="table-body">
                              {dataOuter?.orderDetails?.map((data, index) => {
                                return (
                                  <Index.TableRow
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                    }}
                                    key={data?._id}
                                  >
                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    >
                                      <Index.Typography className="admin-table-data-text">
                                        {index + 1}
                                      </Index.Typography>
                                    </Index.TableCell>

                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    >
                                      <Index.Typography className="admin-table-data-text">
                                        {data?.platform ? data?.platform : "-"}
                                      </Index.Typography>
                                    </Index.TableCell>

                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    >
                                      <Index.Typography className="admin-table-data-text">
                                        {data?.elements ? data?.elements : "-"}
                                      </Index.Typography>
                                    </Index.TableCell>

                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    >
                                      <Index.Typography className="admin-table-data-text">
                                        {data?.totalSeconds
                                          ? data?.totalSeconds
                                          : 0}{" "}
                                        ({data?.unit})
                                      </Index.Typography>
                                    </Index.TableCell>

                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    >
                                      <Index.Typography className="admin-table-data-text">
                                        {" "}
                                        {data?.discountrate
                                          ? data?.discountrate
                                          : 0}
                                      </Index.Typography>
                                    </Index.TableCell>

                                    {/* <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    >
                                      <Index.Typography className="admin-table-data-text">
                                        {" "}
                                        {parseFloat(data?.remainingUnits || 0)}
                                      </Index.Typography>
                                    </Index.TableCell> */}
                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    >
                                      <Index.Typography className="admin-table-data-text">
                                        {" "}
                                        {parseFloat(data?.units || 0)}
                                      </Index.Typography>
                                    </Index.TableCell>

                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      className="table-td"
                                    >
                                      <Index.Typography className="admin-table-data-text">
                                        {parseFloat(
                                          data?.unit == "seconds"
                                            ? (data?.units *
                                                data?.discountrate) /
                                                10 || 0
                                            : data?.units *
                                                data?.discountrate || 0
                                        )?.toLocaleString("en-Us")}
                                      </Index.Typography>
                                    </Index.TableCell>
                                    <Index.TableCell
                                      component="td"
                                      variant="td"
                                      align="right"
                                      className="table-td"
                                    >
                                      {data?.slotAddData?.length ? (
                                        <Index.Box className="admin-table-data-btn-flex ">
                                          <Index.Tooltip
                                            title="View"
                                            arrow
                                            placement="bottom"
                                            className="admin-tooltip"
                                          >
                                            <Index.Button
                                              className="admin-table-data-btn abc"
                                              onClick={() =>
                                                handleOpenViewBookingDetails(
                                                  data
                                                )
                                              }
                                            >
                                              <img
                                                src={PagesIndex.Svg.yelloweye}
                                                className="admin-icon"
                                                alt="View"
                                              />
                                            </Index.Button>
                                          </Index.Tooltip>
                                        </Index.Box>
                                      ) : (
                                        "-"
                                      )}
                                    </Index.TableCell>
                                  </Index.TableRow>
                                );
                              })}
                              <Index.TableRow>
                                <Index.TableCell
                                  component="td"
                                  variant="td"
                                  className="table-td"
                                ></Index.TableCell>
                                <Index.TableCell
                                  component="td"
                                  variant="td"
                                  className="table-td"
                                ></Index.TableCell>
                                <Index.TableCell
                                  component="td"
                                  variant="td"
                                  className="table-td"
                                ></Index.TableCell>
                                <Index.TableCell
                                  component="td"
                                  variant="td"
                                  className="table-td"
                                ></Index.TableCell>
                                {/* <Index.TableCell
                                  component="td"
                                  variant="td"
                                  className="table-td"
                                ></Index.TableCell> */}
                                <Index.TableCell
                                  component="td"
                                  variant="td"
                                  className="table-td"
                                ></Index.TableCell>
                                <Index.TableCell
                                  component="td"
                                  variant="td"
                                  className="table-td"
                                  align="right"
                                >
                                  <Index.Box className="total-text">
                                    Total Amount:
                                  </Index.Box>
                                </Index.TableCell>
                                <Index.TableCell
                                  component="td"
                                  variant="td"
                                  className="table-td"
                                >
                                  <Index.Box className="total-text">
                                    {parseFloat(
                                      dataOuter?.orderDetails?.reduce(
                                        (acc, cur) => {
                                          return cur?.unit == "seconds"
                                            ? acc +
                                                (cur?.units *
                                                  cur?.discountrate) /
                                                  10 || 0
                                            : acc +
                                                cur?.units *
                                                  cur?.discountrate || 0;
                                        },
                                        0
                                      )
                                    )?.toLocaleString("en-Us")}
                                  </Index.Box>
                                </Index.TableCell>{" "}
                                <Index.TableCell
                                  component="td"
                                  variant="td"
                                  className="table-td"
                                ></Index.TableCell>
                              </Index.TableRow>
                            </Index.TableBody>
                          </Index.Table>
                        </>
                      );
                    })}
                  </Index.TableContainer>
                </Index.Box>
              </Index.Box>
            </>
          ) : (
            ""
          )}
        </Index.Box>
      )}
      <Index.Modal
        open={openViewBookingDetails}
        onClose={handleCloseViewBookingDetails}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admin-modal"
      >
        <Index.Box
          sx={style}
          className="admin-view-sales-modal-inner-main admin-modal-inner"
        >
          <Index.Box className="admin-modal-header">
            <Index.Typography
              id="modal-modal-title"
              className="admin-modal-title"
              variant="h6"
              component="h2"
            >
              {" "}
              View Booking Details{" "}
              <span className="sales-order-id-text">
                {/* ({modalData?.subOrderNo}) */}
              </span>
            </Index.Typography>
            <Index.Button
              className="modal-close-btn"
              onClick={handleCloseViewBookingDetails}
            >
              <img
                src={PagesIndex.Svg.closeblack}
                className="admin-modal-close-icon"
                alt="Close"
              />
            </Index.Button>
          </Index.Box>
          <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
            <Index.Box className="grid-row view-order-row">
              <Index.Box
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
              >
                <Index.Box
                  gridColumn={{
                    xs: "span 12",
                    sm: "span 6",
                    md: "span 4",
                    lg: "span 4",
                  }}
                  className="grid-column"
                >
                  <Index.Box className="order-inner-box">
                    <Index.Typography className="order-inner-lable-text">
                      Platform Name:{" "}
                    </Index.Typography>
                    <Index.Typography className="order-inner-value-text">
                      {modalDataOrder?.platform}
                    </Index.Typography>
                  </Index.Box>
                </Index.Box>

                <Index.Box
                  gridColumn={{
                    xs: "span 12",
                    sm: "span 6",
                    md: "span 8",
                    lg: "span 4",
                  }}
                  className="grid-column"
                >
                  <Index.Box className="order-inner-box">
                    <Index.Typography className="order-inner-lable-text">
                      Element:{" "}
                    </Index.Typography>
                    <Index.Typography className="order-inner-value-text">
                      {modalDataOrder?.elements}
                    </Index.Typography>
                  </Index.Box>
                </Index.Box>

                {/* <Index.Box
                  gridColumn={{
                    xs: "span 12",
                    sm: "span 6",
                    md: "span 8",
                    lg: "span 4",
                  }}
                  className="grid-column"
                >
                  <Index.Box className="order-inner-box">
                    <Index.Typography className="order-inner-lable-text">
                      Total Remaining Units:{" "}
                    </Index.Typography>
                    <Index.Typography className="order-inner-value-text">
                      {modalDataOrder?.remainingUnits}
                    </Index.Typography>
                  </Index.Box>
                </Index.Box> */}
              </Index.Box>
            </Index.Box>
            {modalDataOrder?.slotAddData?.map((data) => {
              return (
                <>
                  <Index.Box className="order-show-inner-box view-booking-inner-main">
                    <Index.Box className="order-inner-box view-order-title-main">
                      <Index.Typography className="order-inner-lable-text">
                        Date Type :
                      </Index.Typography>
                      <Index.Typography className="order-inner-value-text">
                        {data?.type === "dateRange" ? "Date Range" : "Date"}
                      </Index.Typography>
                    </Index.Box>
                    <Index.Box className="grid-row view-order-row">
                      <Index.Box
                        display="grid"
                        gridTemplateColumns="repeat(12, 1fr)"
                        gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                      >
                        {data?.type === "dateRange" && (
                          <>
                            <Index.Box
                              gridColumn={{
                                xs: "span 12",
                                sm: "span 6",
                                md: "span 4",
                                lg: "span 4",
                              }}
                              className="grid-column"
                            >
                              <Index.Box className="order-inner-box">
                                <Index.Typography className="order-inner-lable-text">
                                  Start Date :
                                </Index.Typography>
                                <Index.Typography className="order-inner-value-text">
                                  {PagesIndex.moment(data?.startDate).format(
                                    "DD-MM-YYYY"
                                  )}
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>

                            <Index.Box
                              gridColumn={{
                                xs: "span 12",
                                sm: "span 6",
                                md: "span 8",
                                lg: "span 4",
                              }}
                              className="grid-column"
                            >
                              <Index.Box className="order-inner-box">
                                <Index.Typography className="order-inner-lable-text">
                                  End Date :
                                </Index.Typography>
                                <Index.Typography className="order-inner-value-text">
                                  {PagesIndex.moment(data?.endDate).format(
                                    "DD-MM-YYYY"
                                  )}
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                          </>
                        )}
                        {data?.type === "date" && (
                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 6",
                              md: "span 8",
                              lg: "span 4",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="order-inner-box">
                              <Index.Typography className="order-inner-lable-text">
                                Dates :
                              </Index.Typography>
                              <Index.Typography className="order-inner-value-text">
                                {data?.selectedDates
                                  ?.map((value) => value?.fullDate)
                                  .join(", ")}
                              </Index.Typography>
                            </Index.Box>
                          </Index.Box>
                        )}
                      </Index.Box>
                    </Index.Box>
                    <Index.Box className="view-order-outer-main">
                      <Index.Box className="order-inner-box view-order-title-main">
                        <Index.Typography className="order-inner-lable-text">
                          Schedule Type :
                        </Index.Typography>
                        <Index.Typography className="order-inner-value-text">
                          {data?.scheduleType === "timeBand"
                            ? "Time Band"
                            : "Program"}
                        </Index.Typography>
                      </Index.Box>
                      <Index.Box className="grid-row view-order-row">
                        <Index.Box
                          display="grid"
                          gridTemplateColumns="repeat(12, 1fr)"
                          gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                        >
                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 6",
                              md: "span 3",
                              lg: "span 3",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="order-inner-box">
                              <Index.Typography className="order-inner-lable-text">
                                Creative
                              </Index.Typography>
                              <Index.Typography className="order-inner-value-text">
                                {
                                  creativeData?.find(
                                    (value) => value?._id === data?.creative
                                  )?.name
                                }
                              </Index.Typography>
                            </Index.Box>
                          </Index.Box>

                          {data?.scheduleType === "program" && (
                            <Index.Box
                              gridColumn={{
                                xs: "span 12",
                                sm: "span 6",
                                md: "span 6",
                                lg: "span 3",
                              }}
                              className="grid-column"
                            >
                              <Index.Box className="order-inner-box">
                                <Index.Typography className="order-inner-lable-text">
                                  Program
                                </Index.Typography>
                                <Index.Typography className="order-inner-value-text">
                                  {
                                    programData?.find(
                                      (value) => value?._id === data?.program
                                    )?.programName
                                  }
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                          )}

                          {data?.scheduleType === "timeBand" && (
                            <>
                              <Index.Box
                                gridColumn={{
                                  xs: "span 12",
                                  sm: "span 6",
                                  md: "span 6",
                                  lg: "span 3",
                                }}
                                className="grid-column"
                              >
                                <Index.Box className="order-inner-box">
                                  <Index.Typography className="order-inner-lable-text">
                                    From Time
                                  </Index.Typography>
                                  <Index.Typography className="order-inner-value-text">
                                    {PagesIndex.moment(data?.fromTime).format(
                                      "hh:mm A"
                                    )}
                                  </Index.Typography>
                                </Index.Box>
                              </Index.Box>

                              <Index.Box
                                gridColumn={{
                                  xs: "span 12",
                                  sm: "span 6",
                                  md: "span 6",
                                  lg: "span 3",
                                }}
                                className="grid-column"
                              >
                                <Index.Box className="order-inner-box">
                                  <Index.Typography className="order-inner-lable-text">
                                    To Time
                                  </Index.Typography>
                                  <Index.Typography className="order-inner-value-text">
                                    {PagesIndex.moment(data?.toTime).format(
                                      "hh:mm A"
                                    )}
                                  </Index.Typography>
                                </Index.Box>
                              </Index.Box>
                            </>
                          )}
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                    {data?.type === "dateRange" && (
                      <>
                        {data?.weekDays?.map((values) => {
                          return (
                            <WeekdayTableView
                              creativeDuration={data?.creativeDuration}
                              data={values}
                            />
                          );
                        })}
                        <Index.Box className="week-box-outer week-box">
                          <Index.Typography className="week-date-text">
                            Total Creative Seconds:
                          </Index.Typography>
                          <Index.Box className="week-input-box">
                            <Index.Box className="admin-form-group">
                              <Index.TextField
                                fullWidth
                                id="fullWidth"
                                className="admin-form-control"
                                placeholder=""
                                disabled
                                value={data?.weekDays?.reduce(
                                  (acc, cur) =>
                                    acc +
                                    cur.total * (data?.creativeDuration || 1),
                                  0
                                )}
                              />
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                      </>
                    )}
                    {data?.type === "date" && data?.selectedDates?.length ? (
                      <Index.Box className="week-main">
                        <Index.Box className="week-day-name-flex">
                          {data?.selectedDates.map((data, index) => {
                            return (
                              <Index.Typography
                                className="week-day-text"
                                key={data?.day}
                              >
                                {data?.day}
                              </Index.Typography>
                            );
                          })}
                        </Index.Box>
                        <Index.Box className="week-content-main-flex">
                          {data?.selectedDates.map((data, index) => {
                            return (
                              <Index.Box
                                className="week-box"
                                key={`${data?.day}-${data?.onlyDate}`}
                              >
                                <Index.Typography className="week-date-text">
                                  {data?.onlyDate}
                                </Index.Typography>
                                <Index.Box className="admin-input-box week-input-box">
                                  <Index.Box className="admin-form-group">
                                    <Index.TextField
                                      fullWidth
                                      id="fullWidth"
                                      className="admin-form-control"
                                      placeholder="0"
                                      value={
                                        data?.value === 0 ? "" : data?.value
                                      }
                                      disabled
                                      inputProps={{ maxLength: 3 }}
                                    />
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            );
                          })}
                        </Index.Box>
                      </Index.Box>
                    ) : (
                      <></>
                    )}
                  </Index.Box>
                </>
              );
            })}
          </Index.Box>
        </Index.Box>
      </Index.Modal>
    </>
  );
}
